import { styled } from "@mui/material";

export const ButtonWrapper = styled("div")({
  button: {
    alignItems: "center",
    backgroundColor: "#fff",
    borderRadius: "6px",
    display: "flex",
    padding: "8px",
    span: {
      color: "#475257",
      fontSize: "10px",
      fontWeight: "800",
      letterSpacing: "0.15em",
      textTransform: "uppercase",
      whiteSpace: "nowrap",
    },
    i: {
      color: "#475257",
      fontSize: "14px",
    },
    "&:hover": {
      backgroundColor: "#f2f4fd",
      span: { color: "#0190d2" },
      i: { color: "#0190d2" },
    },
  },
});

export const LoaderWrapper = styled("div")({
  "& img": {
    maxWidth: "18px",
    maxHeight: "16px",
  },
});

export const CardContainer = styled("div")(({ theme }) => ({
  backgroundColor: "#ffffff",
  borderRadius: "8px",
  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
  padding: "12px 16px",
  width: "100%",
  height: "fit-content",
  display: "flex",
  flexDirection: "column",

  "&.expandedCardContainer": {
    height: "100vh",
    width: "100vw",
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: 1000,
    padding: "24px",
  },
}));

export const CardContent = styled("div")({
  height: "100%",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  flex: 1,

  "&.expandedCardContent": {
    maxHeight: "calc(100vh - 48px)",
    overflow: "auto",
  },
});

export const ExportButtonContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "8px",

  ".export-button, .detail-button": {
    minWidth: "32px",
    width: "32px",
    height: "32px",
    padding: "0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "none",
    backgroundColor: "transparent",

    "& .MuiButton-endIcon": {
      margin: 0,
      padding: 0,
      position: "absolute",
      right: "50%",
      transform: "translateX(50%)",
      backgroundColor: "#F7FFFC",
      borderRadius: "4px",
      width: "24px",
      height: "24px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },

    "& .MuiSvgIcon-root": {
      color: "#475257",
    },

    "&:hover": {
      border: "none",
      backgroundColor: "transparent",
    },
  },
});

export const ActionsContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: "8px",
});
